import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { SelectorItem, SelectorPopupComponent } from '@common/popups/selector-popup/selector-popup.component';
import { Filterable, FilterableGroup } from '@common/utilities/Filterable';
import { ModalService } from '@common/services/modal.service';

@Component({
  selector: 'text-filter',
  templateUrl: './text-filter.component.html',
  styleUrls: ['./text-filter.component.scss']
})
export class TextFilterComponent {

  constructor(private modal: ModalService) { }

  private _focus = new EventEmitter<TextFilterComponent>();
  private _blur = new EventEmitter<TextFilterComponent>();
  private _focusing: boolean = false;

  @Input()
  public placeholder: string = '';
  @Input()
  public set target(value: Filterable<any> | Filterable<any>[]) {
    
    this._targets = !Array.isArray(value) ? [value] : value;
    this._targets.forEach(i => {
      i.search = this._targets[0].search;
      let lu = {};

      i.groups.forEach(g => {
        let key = [g.name, g.option].join('/');
        if (!lu[key]) lu[key] = g.selected;
        g.selected = lu[key];
      });
    });
  }

  @Output()
  public get focus() {
    return this._focus;
  }

  @Output()
  public get blur() {
    return this._blur;
  }

  private _targets: Filterable<any>[];

  public get search(): string {
    return this._targets[0].search;
  }

  public set search(value: string) {
    value = value.trim();
    this._targets.forEach(i => i.search = value);
  }

  public get groups() {
    return this._targets.many(i => i.groups);
  }

  public get matches() {
    let result = 0;
    this._targets.forEach(i => result += i.matches.length);
    return result;
  }

  public get filtered() {
    return this._targets.first(i => i.filtered, null) != null;
  }

  public get totals() {
    let result = 0;
    this._targets.forEach(i => result += i.source.length);
    return result;
  }

  public get focusing() {
    return this._focusing;
  }

  public select() {
    this.modal.show(SelectorPopupComponent, {
      state: {
        title: 'Lọc hiển thị',
        items: this.groups.group(i => [i.name, i.option].join('/')).map<SelectorItem>(i => ({ name: i.items[0].option, group: i.items[0].name, selected: i.items[0].selected, description: i.items[0].description, icon: i.items[0].icon, state: i.items })),
      }
    }).content.submit.subscribe(groups => {
      groups.forEach(grp => (grp.state as FilterableGroup<any>[]).forEach(org => org.selected = grp.selected));
    });
  }

  public onfocus() {
    this._focusing = true;
    this.focus.emit(this);
  }

  public onblur() {
    this._focusing = false;
    this.blur.emit(this);
  }

  public reset() {
    this._targets.forEach(i => i.reset());
  }
}

